'use client'
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useIsMobile from "@/hooks/useMobile";

interface CustomArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
}

const CustomPrevArrow: React.FC<CustomArrowProps> = ({ className, style = {}, onClick }) => {
  return (
    <div
      className={className}
      style={{ ...style, width: '20px', left: '-15px', height: '20px' }}
      onClick={onClick}
    />
  );
};

const CustomNextArrow: React.FC<CustomArrowProps> = ({ className, style = {}, onClick }) => {
  return (
    <div
      className={className}
      style={{ ...style, width: '20px', right: '-15px', height: '20px' }}
      onClick={onClick}
    />
  );
};

const CustomPrevArrowD: React.FC<CustomArrowProps> = ({ className, style = {}, onClick }) => {
  return (
    <div
      className={className}
      style={{ ...style, width: '30px', left: '20px', zIndex: "10", height: '30px' }}
      onClick={onClick}
    />
  );
};

const CustomNextArrowD: React.FC<CustomArrowProps> = ({ className, style = {}, onClick }) => {
  return (
    <div
      className={className}
      style={{ ...style, width: '30px', right: '20px', height: '30px' }}
      onClick={onClick}
    />
  );
};

interface SliderProps {
  children: React.ReactNode;
  customSettings?: any;
}

const CustomSlider: React.FC<SliderProps> = ({ children, customSettings }) => {
  const mobile = useIsMobile(1000);

  const defaultSettings: any = {
    slidesToScroll: 1,
    nextArrow: mobile ? <CustomNextArrow /> : <CustomNextArrowD />,
    prevArrow: mobile ? <CustomPrevArrow /> : <CustomPrevArrowD />,
    // Add other default settings as needed
  };

  const mergedSettings = { ...defaultSettings, ...customSettings };

  return <Slider {...mergedSettings}>{children}</Slider>;
};

export default CustomSlider;
